module.exports = __webpack_public_path__ + "img/sajou 2023.70c61a5d.webp";